import Pods from './pods'

export default {
  Pods,
}
